import { render, staticRenderFns } from "./epb-textarea.component.vue?vue&type=template&id=4c10aa11&scoped=true"
import script from "./epb-textarea.component.vue?vue&type=script&lang=ts"
export * from "./epb-textarea.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-textarea.component.vue?vue&type=style&index=0&id=4c10aa11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10aa11",
  null
  
)

export default component.exports